import { AxiosResponse } from 'axios';
import { DocumentBirthFormVM } from 'civil-status/view-models/document-birth-form';
import { DateTime } from 'luxon';
import { DocumentBirthCM } from 'shell/models/document-birth';
import { HttpResponse } from 'shell/models/http-response';
// Imposta la zona temporale di default globalmente

export const transformDocumentBirth = (
  response: AxiosResponse<HttpResponse<DocumentBirthCM>>
): DocumentBirthFormVM => {
  const payloadResponse = response.data?.payload;

  const item: DocumentBirthFormVM = {
    indicatorUpdate:
      payloadResponse?.datiAttoNascita?.indicatoreAggiornamento === '0' ||
      !payloadResponse?.datiAttoNascita?.indicatoreAggiornamento
        ? 'È necessario effettuare la convalida dei dati.'
        : '',
    matricola: payloadResponse?.datiAttoNascita?.matricola?.toString() || '',
    surname: payloadResponse?.datiAttoNascita?.cognome || '',
    name: payloadResponse?.datiAttoNascita?.nome || '',
    gender: payloadResponse?.datiAttoNascita?.sesso || '',
    municipalityBirth: payloadResponse?.datiAttoNascita?.comuneNascita || '',
    surnameFather: payloadResponse?.datiAttoNascita?.cognomePadre || '',
    nameFather: payloadResponse?.datiAttoNascita?.nomePadre || '',
    surnameMother: payloadResponse?.datiAttoNascita?.cognomeMadre || '',
    nameMother: payloadResponse?.datiAttoNascita?.nomeMadre || '',
    time: payloadResponse?.datiAttoNascita?.oraNascita
      ? DateTime.fromISO(payloadResponse?.datiAttoNascita?.oraNascita)
      : null,
    birthday: payloadResponse?.datiAttoNascita?.dataNascita
      ? DateTime.fromISO(payloadResponse?.datiAttoNascita?.dataNascita)
      : null,
    year: payloadResponse?.datiAttoNascita?.key?.anno || '',
    registerNumber: payloadResponse?.datiAttoNascita?.key?.numeroRegistro || '',
    documentNumber: payloadResponse?.datiAttoNascita?.key?.numeroAtto?.toString() || '',
    portion: payloadResponse?.datiAttoNascita?.key?.parte || '',
    serie: payloadResponse?.datiAttoNascita?.key?.serie1?.trim() || '',
    serie2: payloadResponse?.datiAttoNascita?.key?.serie2?.trim() || '',
    uploadFile:
      payloadResponse?.attoNascitaCM?.attoByteArray && payloadResponse?.attoNascitaCM?.atto
        ? {
            raw:
              payloadResponse?.attoNascitaCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
            rawTiff: `data:image/png;base64,${payloadResponse?.attoNascitaCM?.attoByteArray}`,
            file: new File(
              payloadResponse?.attoNascitaCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
              payloadResponse?.attoNascitaCM?.nomeFile
            ),
          }
        : undefined,
    annotationInternationalList:
      payloadResponse?.annotazioniAttoNascitaInt?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
    annotationNationalList:
      payloadResponse?.annotazioniAttoNascitaNaz?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
  };
  return item;
};

export const transformDocumentBirthRequestUpdate = (values: DocumentBirthFormVM) =>
  ({
    key: {
      numeroAtto: values.documentNumber || undefined,
      numeroRegistro: values.registerNumber || undefined,
      parte: values.portion || undefined,
      serie1: values.serie || undefined,
      serie2: values.serie2 || undefined,
      anno: values.year || undefined,
    },
    matricola: values.matricola || undefined,
    cognome: values.surname || undefined,
    nome: values.name,
    dataNascita: values.birthday ? values.birthday?.toFormat('yyyy-MM-dd') : undefined,
    oraNascita: values.time || undefined,
    sesso: values.gender || undefined,
    comuneNascita: values.municipalityBirth || undefined,
    // indirizzoNascita: values.
    cognomePadre: values.surnameFather || undefined,
    nomePadre: values.nameFather || undefined,
    cognomeMadre: values.surnameMother || undefined,
    nomeMadre: values.nameMother || undefined,
  } as const);
